import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface Props {
  children: React.ReactNode;
}

const AdminRouteGuard = ({ children }: Props) => {
  const { loading, session, isAuthorized, signOut } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  if (!isAuthorized) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
        <h1 className="font-headline text-3xl text-foreground">Access denied</h1>
        <p className="mt-3 max-w-md text-muted-foreground">
          Your account does not have permission to access the Hadassah Homes admin area. If you
          believe this is a mistake, contact the site administrator.
        </p>
        <Button variant="outline" onClick={signOut} className="mt-6 rounded-none">
          Sign out
        </Button>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminRouteGuard;
